import {METODOBONO, TIPOMOVIMIENTO} from "../../Constantes";

export const adaptador_abonos_movimientos = ({abonos, origen, reserva}) => {

    let arrAbonos = []
    for (let i = 0; i < abonos.length; i++) {
        let obj = {
            descripcion: `Abono habitacion ${reserva.numero} - ${reserva.nombres} `,
            fecha: abonos[i].fecha ? abonos[i].fecha : new Date().getTime(),
            id: abonos[i].fecha ? abonos[i].fecha + 'TOS' : new Date().getTime() + i + 'TOS',
            tipo: TIPOMOVIMIENTO[0].nombre,
            valor: abonos[i].valor,
            origen: abonos[i].origen ? abonos[i].origen : origen,
            metodo: abonos[i].metodo ? abonos[i].metodo : METODOBONO[0]
        }
        arrAbonos.push(obj)
    }


    return arrAbonos

}